"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyInfoErrorCode = exports.MyInfoErrorCodeName = void 0;
const ErrorCodeV2_1 = require("../../error/ErrorCodeV2");
var MyInfoErrorCodeName;
(function (MyInfoErrorCodeName) {
    // currently used in `singpass/callback` and lifesg error page
    MyInfoErrorCodeName["MYINFO_404"] = "MYINFO_404";
    MyInfoErrorCodeName["CONSENT_REJECTED"] = "CONSENT_REJECTED";
    MyInfoErrorCodeName["MYINFO_ERROR"] = "MYINFO_ERROR";
})(MyInfoErrorCodeName || (exports.MyInfoErrorCodeName = MyInfoErrorCodeName = {}));
var MyInfoErrorCode;
(function (MyInfoErrorCode) {
    MyInfoErrorCode.MYINFO_404 = Object.freeze(new ErrorCodeV2_1.ErrorCodeV2({ code: MyInfoErrorCodeName.MYINFO_404, httpStatusCode: 400, message: "No Myinfo profile" }));
    MyInfoErrorCode.CONSENT_REJECTED = Object.freeze(new ErrorCodeV2_1.ErrorCodeV2({
        code: MyInfoErrorCodeName.CONSENT_REJECTED,
        httpStatusCode: 400,
        message: "Myinfo consent rejected",
    }));
    MyInfoErrorCode.MYINFO_ERROR = Object.freeze(new ErrorCodeV2_1.ErrorCodeV2({
        code: MyInfoErrorCodeName.MYINFO_ERROR,
        httpStatusCode: 500,
        message: "Myinfo error",
        logAsError: true,
    }));
})(MyInfoErrorCode || (exports.MyInfoErrorCode = MyInfoErrorCode = {}));
//# sourceMappingURL=error.js.map